module.exports=require("node-i18n-util/lib/client-bundle")("nls/common.properties")